module.exports = __webpack_public_path__ + "static/ecanta-sorunlar-49f4858e0b7dd2ad3f326947567b1483.png";